//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from "vuex";
import AWalletBaseCredentials from "./AWalletBaseCredentials.vue";
import AQCheckbox from "../AQCheckbox/AQCheckbox.vue";

export default {
    name: "AWalletAccount",
    components: {
        AQCheckbox,
        AWalletBaseCredentials
    },
    props: {
        isFromMnemonic: {
            type: Boolean,
            default: false
        },
        embedded: {
            type: Boolean,
            default: false
        },
        value: {
            type: Object
        },
        accounts: {
            type: Array,
            required: true
        },
        walletType: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            model: this.value,
            saveMethod: "local",
            withPassword: true
        };
    },
    computed: {
        ...mapGetters({
            getSelectedAccount: "aWallet/getSelectedAccount",
            getSaveForLater: "aWallet/getSaveForLater"
        }),
        selectedAccount() {
            return this.getSelectedAccount;
        },
        saveForLater: {
            get() {
                return this.getSaveForLater;
            },
            set(value) {
                this.setSaveForLater(value);
            }
        }
    },
    watch: {
        value(val) {
            this.model = val;
        }
    },
    created() {
        this.setSelectedAccount(this.accounts[0]);
        if (!this.embedded) {
            this.setSaveForLater(true);
        }
        if (this.walletType === "keystoreFile") {
            this.withPassword = false;
        }
    },
    methods: {
        ...mapMutations({
            setSelectedAccount: "aWallet/setSelectedAccount",
            setSaveForLater: "aWallet/setSaveForLater",
            setCtaDisabled: "aWallet/setCtaDisabled"
        }),
        checkForErrors() {
            let hasErrors = false;
            if (this.$refs["import-credentials"].hasErrors()) {
                hasErrors = true;
            }

            return hasErrors;
        },
        saveType() {
            this.$emit("saveMethodVal", this.saveMethod);
        },
        selectAccount(event) {
            this.setSelectedAccount(event);
        },
        onGenerateAccountClick() {
            this.$emit("generate-account");
        }
    }
};
